import styles from './MathFloater.module.css';

/** Decorative symbol tile positioned in the `HeroWidgets` canvas; `--px` scales all its dimensions. */
export default function MathFloater({symbol, left, top, size, fontSize, radius, bg, fg, rotate, depth, duration, delay, playing}) {
    return (
        <div
            className={depth === 'behind' ? styles.behind : styles.front}
            style={{left: `calc(var(--px) * ${left})`, top: `calc(var(--px) * ${top})`}}
        >
            <div
                className={playing ? styles.float : undefined}
                style={playing ? {animationDuration: `${duration}s`, animationDelay: `${delay}s`} : undefined}
            >
                <div
                    className={styles.tile}
                    style={{
                        width: `calc(var(--px) * ${size})`,
                        height: `calc(var(--px) * ${size})`,
                        borderRadius: radius === '50%' ? '50%' : `calc(var(--px) * ${radius})`,
                        background: bg,
                        color: fg,
                        fontSize: `calc(var(--px) * ${fontSize})`,
                        transform: `rotate(${rotate}deg)`,
                    }}
                >
                    {symbol}
                </div>
            </div>
        </div>
    );
}
